export const guidelines = [
  "Each time you make a contribution that is approved, your wallet will be updated with GHC5.00",
  "Once your balance reaches GHC50.00, payment will be made to the mobile money number associated with your account",
  "Contributions based on Editor Prompts are worth twice as much as regular contributions! Watch out for prompts and earn GHC10.00 per article",
];
